<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="27" viewBox="0 0 20 27">
        <defs>
            <linearGradient id="4r3y4573fa" x1="77.997%" x2="22.003%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="#2C6CA3"/>
                <stop offset="100%" stop-color="#2D3E4F"/>
            </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <g>
                <g>
                    <path fill="url(#4r3y4573fa)" d="M9.92 0l.004.004.003-.002c3.767 3.153 6.424 5.373 7.972 6.667l.27.225 1.35 1.128c1.475 8.034-1.725 14.21-9.6 18.528v-.01l-.368-.205C1.965 22.03-1.102 15.927.35 8.022l1.759-1.473.305-.256L9.92.01z" transform="translate(-154 -164) translate(154 164)"/>
                    <g fill="#FFF">
                        <path d="M3.63 0c1.354 0 2.42 1.246 2.42 2.75 0 .018 0 .036-.002.053.713.303 1.213 1.012 1.213 1.837v2.855c0 1.105-.896 2-2 2H2c-1.105 0-2-.895-2-2V4.64c0-.825.5-1.534 1.214-1.84l-.004-.05C1.21 1.246 2.277 0 3.63 0zm0 5.28c-.546 0-.99.444-.99.99 0 .432.276.799.66.935V8.58h.66V7.205c.385-.136.66-.503.66-.934 0-.547-.443-.99-.99-.99zm0-4.18c-.685 0-1.275.646-1.339 1.498l-.002.042h2.683c-.044-.822-.578-1.462-1.222-1.533L3.63 1.1z" transform="translate(-154 -164) translate(154 164) translate(6.31 8.912)"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'certify-icon'
}
</script>
